import { render, staticRenderFns } from "./OrdersMapDepartments.vue?vue&type=template&id=0d5c9c48&scoped=true"
import script from "./OrdersMapDepartments.vue?vue&type=script&lang=js"
export * from "./OrdersMapDepartments.vue?vue&type=script&lang=js"
import style0 from "./OrdersMapDepartments.vue?vue&type=style&index=0&id=0d5c9c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c9c48",
  null
  
)

export default component.exports